import {useState} from "react";

import {collection, getDocs, query, updateDoc, where} from "firebase/firestore";
import {Button, Col, Modal, Row, Spinner} from "react-bootstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faArrowLeft, faSave} from "@fortawesome/free-solid-svg-icons";
import {RREmployeeType} from "../../types/RREmployeeType";
import {RREventType} from "../../types/RREventType";
import {appFirestore} from "../../../index";
import {calendarDataConverter} from "../../../firebase/FirebaseCalendarLoader";
import {deleteCalendarItemsWithChangeLog} from "../calendar/change-log/calendarChangeLog";
import {useAppSelector} from "../../hooks";
import {selectCurrentEmployee} from "../../../features/AppStateSlice";


export interface Props {
    doc: RREventType;
    onDone: () => any;
}

export function EventsDelete({doc, onDone}: Props) {
    const [deleting, setDeleting] = useState(false);
    const currentEmployee = useAppSelector(selectCurrentEmployee);

    const deleteEvent = async () => {
        setDeleting(true);
        await updateDoc(doc.ref!, {isDeleted: true});
        const allCalendarData = await getDocs(query(collection(appFirestore,  "calendar"),
            where("eventId", "==", doc.id)));
        const allCalendar = calendarDataConverter(allCalendarData.docs);
        await deleteCalendarItemsWithChangeLog(
            allCalendar
                .filter(calendar => calendar.ref)
                .map(calendar => ({
                    ref: calendar.ref!,
                    context: {eventNumber: doc.eventNumber, eventName: doc.eventName},
                })),
            currentEmployee
        );
        setDeleting(false);
        onDone();
    }

    return (
        <>
            <Modal.Body>
                <h5 className={"mb-3"}>
                    Изтриване на събитие
                </h5>

                <div className={"text-danger"}>
                    Моля, потвърдете изтриването на събитие <strong className={"text-primary"}>{doc.eventName}</strong>!
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Row className={"w-100"}>
                    {
                        deleting && <Col xs={12} className={"text-center"}>
                            <Spinner animation={"border"}/>
                        </Col>
                    }

                    {
                        !deleting &&
                        <>
                            <Col xs={6}>
                                <Button variant={"outline-secondary"} onClick={() => {
                                    onDone()
                                }}>
                                    <FontAwesomeIcon icon={faArrowLeft}/> Към списъка
                                </Button>
                            </Col>
                            <Col xs={6} className={"text-end"}>
                                <Button onClick={() => deleteEvent()} variant={"danger"}>
                                    <FontAwesomeIcon icon={faSave}/> Изтрий
                                </Button>
                            </Col>
                        </>
                    }
                </Row>
            </Modal.Footer>
        </>
    )
}
